module.exports = __webpack_public_path__ + "img/9788949120911.53d70f74.jpg";